import { Badge } from "native-base";

export default Badge;